var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'jsk-code-block',
    _vm.hasSelection ? '' : 'no-selection',
    _vm.hasLineNumbers ? '' : 'no-line-numbers',
    'jsk-code-block-copy-' + _vm.codeBlockCopyButtonTrigger,
    'jsk-code-block-run-' + _vm.codeBlockRunButtonTrigger
  ],style:({
    borderColor: _vm.codeBlockTheme === 'light' ? '#DDDDDD' : '#272822',
    width: _vm.width
  })},[_c('codemirror',{ref:"codemirror",staticClass:"jsk-code-block-codemirror",style:({
      maxHeight: _vm.maxHeight
    }),attrs:{"options":_vm.cmOption},on:{"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('div',{staticClass:"jsk-code-block-buttons"},[(_vm.isCopyAllowed)?_c('el-button',{staticClass:"jsk-code-block-copy",attrs:{"type":_vm.copyButtonType,"size":"mini"},on:{"click":_vm.onCopy}},[_vm._v(" "+_vm._s(_vm.copyButtonText)+" ")]):_vm._e(),(_vm.isRunAllowed)?_c('el-button',{staticClass:"jsk-code-block-run",attrs:{"type":"info","size":"mini"},on:{"click":_vm.onRun}},[_vm._v(" "+_vm._s(_vm.codeBlockRunText)+" ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }